module.exports = __webpack_public_path__ + "static/img_1797-9ff9bd028e4a9a36b8e45ebc37602e8a.webp";